export * from "./engine.alpha.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import engine.alpha.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./engine.alpha.pure";
import { RegisterEnginesExtensionsEngineAlpha } from "./engine.alpha.pure";
RegisterEnginesExtensionsEngineAlpha();
//# sourceMappingURL=engine.alpha.js.map